const TRIGGER_TARGET_TYPE = {
  ALL: 'all',
  NEW: 'new',
  OLD: 'old',
};

export default { TRIGGER_TARGET_TYPE };
